import React from 'react';
import {CardTitle, Input} from 'reactstrap';
import renderExplanation from './Explanation';


const MultiTextTask = ({title, description, explanation, showCorrect, correctValues, inputType}) => {
    const getInput = (placeholder) => {
        const answerIndex = placeholder.replace('{', '').replace('}', '');
        if (showCorrect === true) {
            switch (inputType) {
                case 'shortWithPlaceholder':
                case 'short': {
                    return <React.Fragment>
                        <input className='TASK__input' />
                        <span className='Task--correct'>{correctValues[answerIndex]}</span>
                    </React.Fragment>
                }
                case 'long': {
                    return <React.Fragment>
                        <Input className='TASK__input' />
                        <span className='Task--correct'>{correctValues[answerIndex]}</span>
                    </React.Fragment>
                }
                case 'textarea':
                default:{
                    return <React.Fragment>
                        <Input type='textarea' className='TASK__input-small' />
                        <span className='Task--correct'>{correctValues[answerIndex]}</span>
                    </React.Fragment>
                }
            }
        } else {
            switch (inputType) {
                case 'short': {
                    return <input className='TASK__input' />
                }
                case 'long': {
                    return <Input className='TASK__input'/>
                }
                case 'shortWithPlaceholder': {
                    return <input className='TASK__input' placeholder={correctValues[answerIndex].charAt(0)}/>
                }
                case 'textarea':
                default:{
                    return <Input type='textarea' className='TASK__input' />
                }

            }
        }
    }

    const renderDescription = () => {
        const re = /({\d+})/;
        const splits = description.split(re)
        return splits.map((value, id) => (<React.Fragment key={id}>
            {
                value.match(re) ? getInput(value) : <span dangerouslySetInnerHTML={{ __html: value }} />
            }
        </React.Fragment>))
    }

    return <>
        <CardTitle dangerouslySetInnerHTML={{ __html: title }} />
        {renderDescription()}
        {(showCorrect && explanation)? renderExplanation(explanation) : undefined}
    </>
}

export default MultiTextTask;